import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";
import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import BackButton from "web/react/components/buttons/back-button/back-button";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import styles from "./overlay.css";

function Overlay({ title, onClose, isOpen, children }) {
    const appElement = useRef(null);
    const childrenElement = useRef(null);
    const [animationReady, setAnimationReady] = useState(false);

    useEffect(() => {
        Modal.setAppElement(appElement.current);
    });

    function handleOpen() {
        setAnimationReady(true);
        disableBodyScroll(childrenElement.current);
    }
    function handleClose() {
        if (animationReady) {
            setAnimationReady(false);
        }
        clearAllBodyScrollLocks();
        onClose();
    }

    return (
        <div ref={appElement}>
            <Modal
                overlayClassName={classnames(styles.background, { [styles.open]: animationReady })}
                className={styles.overlay}
                appElement={document.body}
                onAfterOpen={handleOpen}
                onRequestClose={handleClose}
                closeTimeoutMS={400}
                isOpen={isOpen}
            >
                <div className={styles.header}>
                    <span className={styles.back}>
                        <BackButton onClick={handleClose} />
                    </span>
                    <span className={styles.title}>{title}</span>
                    <span className={styles.close}>
                        <CloseButton onClick={handleClose} />
                    </span>
                </div>
                <div ref={childrenElement} className={styles.content}>
                    {children}
                </div>
            </Modal>
        </div>
    );
}

export default Overlay;

Overlay.propTypes = {
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    children: PropTypes.node,
};

Overlay.defaultProps = {
    isOpen: false,
};
